import { create } from 'zustand'

export interface GettingStartedChoices {
  dismissedAt: string | null
  welcomedAt: string | null
  doneSteps: string[]
}

interface GettingStartedState extends GettingStartedChoices {
  // Null until the signed-in user's choices are read from storage.
  hydratedForUser: string | null
  hydrate: (userId: string, choices: GettingStartedChoices) => void
  dismiss: (at: string) => void
  welcome: (at: string) => void
  setDoneSteps: (stepKeys: string[]) => void
}

export const useGettingStartedStore = create<GettingStartedState>((set) => ({
  dismissedAt: null,
  welcomedAt: null,
  doneSteps: [],
  hydratedForUser: null,
  hydrate: (userId, choices) => set({ hydratedForUser: userId, ...choices }),
  dismiss: (at) => set({ dismissedAt: at }),
  welcome: (at) => set({ welcomedAt: at }),
  setDoneSteps: (stepKeys) => set({ doneSteps: stepKeys }),
}))
